import * as S from './styles'
import { useTranslation } from 'react-i18next'

const CustomCytology = () => {
  const { t } = useTranslation()

  return (
    <S.CustomCytologyContainer>
      <div>
        <ul>
          {Array.from({ length: 11 }).map((_, idx) => (
            <li>{t(`titles.cytology1.${idx + 1}`)}</li>
          ))}
        </ul>
        <p>{t('subtitles.cytology4')}</p>
        <ul>
          {Array.from({ length: 5 }).map((_, idx) => (
            <li>{t(`titles.cytology2.${idx + 1}`)}</li>
          ))}
        </ul>
      </div>
    </S.CustomCytologyContainer>
  )
}

export default CustomCytology
